// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");

function ErrorComponent(props) {
  return JsxRuntime.jsx("div", {
    children: props.message,
    className: "bg-white shadow-sm rounded-md p-4 sm:p-5"
  });
}

function ErrorComponent$Large(props) {
  return JsxRuntime.jsx("div", {
    children: props.children,
    className: "text-center leading-normal text-base sm:text-lg md:text-xl"
  });
}

let Large = {
  make: ErrorComponent$Large
};

let make = ErrorComponent;

exports.Large = Large;
exports.make = make;
/* react/jsx-runtime Not a pure module */
